import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=2fbae0b5&scoped=true"
import script from "./BaseInputNumber.vue?vue&type=script&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&lang=js"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&id=2fbae0b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbae0b5",
  null
  
)

export default component.exports